import {
  Sidebar,
  SidebarContent,
  SidebarInset,
  SidebarProvider,
  TooltipProvider,
} from "@pdfking/components"
import type { ComponentChildren } from "preact"

import type { SitePage } from "./SiteRail"
import { SiteRail } from "./SiteRail"

/** A site page: the site's rail, lit on `active`, and `panel` (the docs'
 * navigation) open beside it. */
export const Layout = ({
  active,
  children,
  panel,
}: {
  active: SitePage
  children: ComponentChildren
  panel: ComponentChildren
}) => (
  <TooltipProvider delayDuration={0}>
    <SidebarProvider open={Boolean(panel)}>
      <Sidebar collapsible="icon">
        <div className="flex h-full min-w-0 flex-row">
          <SiteRail active={active} bottom={undefined} top={undefined} />
          <SidebarContent className="group-data-[collapsible=icon]:hidden">{panel}</SidebarContent>
        </div>
      </Sidebar>
      <SidebarInset className="bg-background text-foreground">{children}</SidebarInset>
    </SidebarProvider>
  </TooltipProvider>
)
